import React from 'react'
import { connect, useSelector } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { RouteComponentProps } from 'react-router-dom'
import { Dispatch } from 'redux'
import { useTranslation } from 'react-i18next'

import { ICompany, IShopByCompany } from '@cbgms/api'
import withData from '@cbgms/base/http/WithData'
import { compose } from '@cbgms/base/utils/compose'

import CompanyForm from 'app-support/company/components/CompanyForm'
import { listShopByCompanyUUID } from 'app-support/shops/state/actions'
import { getCompany, resetCompany, updateCompany } from 'app-support/company/state/actions'
import { IRootReducerState } from 'state/reducers'
import CustomTypography from 'app-support/CustomTypography'

interface MapStateToProps {
  shops: IShopByCompany[]
  initialValues: Partial<ICompany>
}

const mapStateToProps = (state: IRootReducerState) => ({
  shops: state.shops,
  initialValues: state.company
})

interface MapDispatchToProps {
  getCompany: typeof getCompany
  listShopByCompanyUUID: typeof listShopByCompanyUUID
  resetCompany: typeof resetCompany
  updateCompany: typeof updateCompany
}

const mapDispatchToProps: MapDispatchToProps = { getCompany, listShopByCompanyUUID, resetCompany, updateCompany }

type RouteParams = RouteComponentProps<{ companyUUID: string }>

interface Props extends MapStateToProps, MapDispatchToProps, RouteParams {}

const enhance = compose<Props, RouteParams>(
  connect(mapStateToProps, mapDispatchToProps),
  withData(async (props: Props) => {
    const { match } = props

    await Promise.all([props.getCompany(match.params.companyUUID), props.listShopByCompanyUUID(match.params.companyUUID)])
  })
)

export const onSubmit = async (values: ICompany, _: Dispatch, props: Props) => {
  const { match } = props

  try {
    await props.updateCompany(match.params.companyUUID, values)
    await props.getCompany(props.match.params.companyUUID)
  } catch (error) {
    throw error
  }
}

function CompanyFormEdit(props: Props) {
  const { t } = useTranslation()
  const notifier = useNotifier()
  const companyName = useSelector<IRootReducerState, string>(state => state.company.Name)

  const onSubmitSuccess = () => {
    notifier.success(t('Company.SuccessfullyUpdated'))
  }

  React.useEffect(() => {
    return () => {
      props.resetCompany()
    }
  }, [])

  return (
    <>
      <CustomTypography text={companyName} level='h5' fontWeight='bold' />
      <div className='companyForm'>
        <CompanyForm
          {...props}
          form='company_edit'
          redirectToURL='/companies'
          isEdit
          onSubmit={onSubmit}
          onSubmitSuccess={onSubmitSuccess}
        />
      </div>
    </>
  )
}

export default enhance(CompanyFormEdit)
